import Flex from "../../../../../components/Flex/Flex";

export default function CalendarMoreLinkContent({ num }) {
	return (
		<Flex style={{ justifyContent: "center" }}>
			<p>{num}</p>
		</Flex>
	);
}
